import { render, staticRenderFns } from "./tabExternalProjectProposalChangeApply.vue?vue&type=template&id=aa8a34e6&scoped=true&"
import script from "./tabExternalProjectProposalChangeApply.vue?vue&type=script&lang=ts&"
export * from "./tabExternalProjectProposalChangeApply.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8a34e6",
  null
  
)

export default component.exports